var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 131,
    viewBox: "0 0 185 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87634 25.0924H86.5225L86.4217 25.2671H86.7489V58.9186H184.034V80.5866H174.646V130.707H0.247264V25.2671L9.87634 25.0924ZM148.887 125.49H125.105V107.114H148.887V125.49ZM148.887 101.897H125.105V80.5866H148.887V101.897ZM154.104 107.114V125.49H169.431V107.114H154.104ZM169.431 101.897H154.104V80.5866H169.431V101.897ZM119.888 101.897V80.5866H86.7489V101.897H119.888ZM86.7489 107.114V125.49H119.888V107.114H86.7489ZM59.6702 125.49V80.5866H81.5336V125.49H59.6702ZM32.9878 125.49V80.5866H54.4549V125.49H32.9878ZM27.7726 80.5866V83.0113H27.7564V125.49H6.29106V80.5866H27.7726ZM6.29106 75.3713V64.1356H27.7726V75.3713H6.29106ZM32.9878 75.3713V64.1356H54.4549V75.3713H32.9878ZM59.6702 75.3713V64.1356H81.5336V75.3713H59.6702ZM86.7489 75.3713V64.1356H178.817V75.3713H86.7489ZM81.5336 58.9186H5.46251V31.1548H81.5336V58.9186Z",
    fill: "#255056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.246826 25.0898L43.1505 0.319376L45.759 4.83745L2.85534 29.6079L0.246826 25.0898Z",
    fill: "#255056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.599 4.81105L83.5266 29.5953L86.1352 25.0772L43.2075 0.292969L40.599 4.81105Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.8ff1caa82e1b30604cb7cf80d51f7074.svg";
export { ForwardRef as ReactComponent };